"use strict";

const organizationName = $("#organizationName").val();
const mapLatitude = $("#mapLatitude").val();
const mapLongitude = $("#mapLongitude").val();
//const mapZoom = $("#mapZoom").val();
const mapZoom = 9;
const defaultImage = $("#defaultImage").val();
const timezone = $("#time-zone").val();
let map;
let markers = [],
  markerData = [];
let infowindow = new google.maps.InfoWindow({
  maxWidth: 400,
  minWidth: 280,
});
const deviceId = "HGT821";
let filterTimeout;
let flowMeterData = [];

// ===== Custom ORG064: beberapa device digabung jadi 1 card =====
// Device dalam grup yang sama dirender sebagai 1 card dengan nilai dijumlahkan.
const MERGED_DEVICE_GROUPS = [["HGT1251", "HGT1252"]];
// 'two-windows'   -> buka 2 InfoWindow sekaligus saat card gabungan diklik
// 'single-window' -> 1 InfoWindow berisi data gabungan
const MERGE_POPUP_MODE = "two-windows";
let mergedInfoWindows = [];

function findMergeGroupIndex(deviceId) {
  const id = String(deviceId || "").toUpperCase();
  if (!id) return -1;
  return MERGED_DEVICE_GROUPS.findIndex((group) =>
    group.some((x) => String(x).toUpperCase() === id),
  );
}

function sumNullable(a, b) {
  const va = a == null || isNaN(Number(a)) ? null : Number(a);
  const vb = b == null || isNaN(Number(b)) ? null : Number(b);
  if (va == null && vb == null) return null;
  return (va ?? 0) + (vb ?? 0);
}

// Gabung device dalam 1 grup jadi 1 baris: flowMonth & flowTotal dijumlahkan,
// nama/slug/koordinat tetap milik pos, status online bila salah satu online.
function mergeFlowMeterData(data) {
  const result = [];
  const consumedGroups = new Set();

  data.forEach((item) => {
    const groupIndex = findMergeGroupIndex(item.deviceId);

    if (groupIndex === -1) {
      result.push(item);
      return;
    }

    if (consumedGroups.has(groupIndex)) return;
    consumedGroups.add(groupIndex);

    const groupIds = MERGED_DEVICE_GROUPS[groupIndex].map((x) =>
      String(x).toUpperCase(),
    );
    const devices = data.filter((x) =>
      groupIds.includes(String(x.deviceId || "").toUpperCase()),
    );

    if (devices.length < 2) {
      result.push(item);
      return;
    }

    const primary = devices[0];
    const latest =
      devices
        .filter((x) => x.readingHour != null)
        .sort((a, b) => new Date(b.readingHour) - new Date(a.readingHour))[0] ||
      null;
    const installedDates = devices
      .map((x) => x.installedDate)
      .filter(Boolean)
      .sort();

    result.push({
      ...primary,
      ...(latest || {}),
      id: primary.id,
      name: primary.name,
      slug: primary.slug,
      latitude: primary.latitude,
      longitude: primary.longitude,
      jenisUsaha: primary.jenisUsaha,
      isMerged: true,
      deviceIds: devices.map((x) => x.deviceId),
      deviceId: devices.map((x) => x.deviceId).join(", "),
      unitDisplay: latest?.unitDisplay ?? primary.unitDisplay,
      flowMonth: devices.reduce(
        (acc, d) => sumNullable(acc, d.flowMonth),
        null,
      ),
      flowTotal: devices.reduce(
        (acc, d) => sumNullable(acc, d.flowTotal),
        null,
      ),
      deviceStatus: devices.some((x) => x.deviceStatus === "online")
        ? "online"
        : "offline",
      readingHour: latest ? latest.readingHour : null,
      batteryVoltage: latest ? latest.batteryVoltage : primary.batteryVoltage,
      batteryCapacity: latest
        ? latest.batteryCapacity
        : primary.batteryCapacity,
      installedDate: installedDates.length
        ? installedDates[0]
        : primary.installedDate,
      devices,
    });
  });

  return result;
}

// Nama card gabungan dibersihkan dari kode device, mis. "PT. MUSIRAWAS CITRA HARPINDO (PKS1)"
function displayStationName(name) {
  return String(name || "")
    .replace(/\s*\([^()]*\)\s*$/, "")
    .trim();
}

// Rincian nilai tiap device di dalam card gabungan (muncul saat card diklik)
function buildDeviceBreakdownContent(devices, fallbackUnit) {
  const rows = (devices || [])
    .map((d) => {
      const hasReading = d.readingHour != null;
      const readingAt = hasReading
        ? moment
            .parseZone(d.readingHour)
            .locale("id")
            .format("DD MMM YYYY HH:mm")
        : "Belum mengirim data";
      const status =
        d.deviceStatus == "online" ? "text-success" : "text-danger";
      const unit = d.unitDisplay ?? fallbackUnit ?? "";

      const safeDevice = encodeURIComponent(JSON.stringify(d)).replace(
        /'/g,
        "%27",
      );

      return `
        <div class="device-breakdown-item" data-device-item='${safeDevice}'>
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <small class="mdi mdi-circle ${status} me-1" style="font-size: 8px;"></small>
              <span class="badge badge-outline-secondary rounded-1" style="color: #A9ABB8;border-color: #A9ABB8;">${d.deviceId}</span>
            </div>
            <small class="text-muted" style="font-size: 10px;">${readingAt}</small>
          </div>
          <div class="device-breakdown-name text-uppercase text-truncate" title="${d.name ?? ""}">${d.name ?? "-"}</div>
          <div class="d-flex justify-content-between mt-1">
            <div class="text-center" style="width: 50%;">
              <small class="text-muted d-block" style="font-size: 10px;">Volume Bulan Ini</small>
              <span class="fw-bold text-dark" style="font-size: 12px;">
                ${d.flowMonth == null ? "-" : formatNumber(d.flowMonth)}
                <span class="text-muted"><sup>${unit}</sup></span>
              </span>
            </div>
            <div class="text-center" style="width: 50%;">
              <small class="text-muted d-block" style="font-size: 10px;">Totalizer</small>
              <span class="fw-bold text-dark" style="font-size: 12px;">
                ${d.flowTotal == null ? "-" : formatNumber(d.flowTotal)}
                <span class="text-muted"><sup>${unit}</sup></span>
              </span>
            </div>
          </div>
        </div>`;
    })
    .join("");

  return `
        <small class="fw-semibold text-muted d-block mb-2" style="font-size: 10px; letter-spacing: .3px;">RINCIAN PER DEVICE</small>
        ${rows}`;
}

// function clearSearch() {
//   $("#filter-pos").val("");
//   $("#clear-search").hide();
//   filterPos();
// }

function clearSearch() {
  $("#filter-pos").val("");
  $("#filter-kategori").val(""); // Opsional: reset kategori juga
  $("#filter-status").val(""); // Opsional: reset status juga
  filterPos();
}

// Update filterPos untuk show/hide clear button
// function filterPos() {
//   const searchValue = $("#filter-pos").val().toLowerCase().trim();
//   let visibleCount = 0;

//   // Show/hide clear button
//   $("#clear-search").toggle(searchValue !== "");

//   $(".no-results").remove();

//   if (searchValue === "") {
//     $(".card-station-flow").show();
//     visibleCount = $(".card-station-flow").length;
//   } else {
//     $(".card-station-flow").each(function () {
//       const name = $(this).data("name") || "";
//       const deviceId = $(this).data("device-id") || "";
//       const isMatch =
//         name.includes(searchValue) || deviceId.includes(searchValue);
//       $(this).toggle(isMatch);
//       if (isMatch) visibleCount++;
//     });
//   }

//   $("#total-flow").text(visibleCount);

//   if (visibleCount === 0 && searchValue !== "") {
//     $("#tab-flow").append(`
//       <div class="text-center p-4 text-muted no-results">
//         <i class="bi bi-search" style="font-size: 3rem;"></i>
//         <p class="mt-2 mb-0">Tidak ada hasil untuk "<strong>${searchValue}</strong>"</p>
//       </div>
//     `);
//   }
// }

// // Function debounce
// function debounce(func, wait) {
//   let timeout;
//   return function executedFunction(...args) {
//     const later = () => {
//       clearTimeout(timeout);
//       func(...args);
//     };
//     clearTimeout(timeout);
//     timeout = setTimeout(later, wait);
//   };
// }

function filterPos() {
  // 1. Ambil semua nilai filter
  const searchVal = $("#filter-pos").val().toLowerCase().trim();
  const kategoriVal = $("#filter-kategori").val().toLowerCase();
  const statusVal = $("#filter-status").val().toLowerCase();

  let visibleCount = 0;

  // Show/hide tombol X (clear)
  $("#clear-search").toggle(searchVal !== "");

  // Hapus pesan "tidak ditemukan" jika ada
  $(".no-results").remove();

  $(".card-station-flow").each(function () {
    const $el = $(this);

    // 2. Ambil data dari atribut elemen
    const name = ($el.data("name") || "").toLowerCase();
    const deviceId = ($el.data("device-id") || "").toLowerCase();
    const kategori = ($el.data("kategori") || "").toLowerCase();
    const status = ($el.data("status") || "").toLowerCase();

    // 3. Logika Pencocokan (Multi-filter)
    const matchText =
      searchVal === "" ||
      name.includes(searchVal) ||
      deviceId.includes(searchVal);
    const matchKategori = kategoriVal === "" || kategori === kategoriVal;
    const matchStatus = statusVal === "" || status === statusVal;

    // Item ditampilkan hanya jika semua kondisi TRUE
    if (matchText && matchKategori && matchStatus) {
      $el.show();
      visibleCount++;
    } else {
      $el.hide();
    }
  });

  // Update total count display
  $("#total-flow").text(visibleCount);

  // 4. Tampilkan pesan jika tidak ada hasil
  if (visibleCount === 0) {
    $("#tab-flow").append(`
      <div class="text-center p-4 text-muted no-results">
        <i class="bi bi-search" style="font-size: 3rem;"></i>
        <p class="mt-2 mb-0">Oops! Tidak ada data yang sesuai dengan filter tersebut.</p>
      </div>
    `);
  }
}

// Fungsi Debounce tetap sama
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function loadCCTV(deviceId) {
  let carouselHtml = '<div class="owl-carousel owl-theme" id="carousel-cctv">';

  const offlineImageUrl = `/images/offline-cctv.png`;

  // Data CCTV statis
  const cctvData = [
    { name: "CCTV Belum Tersedia", image: offlineImageUrl, status: "offline" },
  ];

  cctvData.forEach((cctv) => {
    carouselHtml += `
      <div class="item">
        <div class="card border-0 shadow-sm">

          <!-- Gambar CCTV - Lebih kecil -->
          <div class="position-relative bg-secondary" style="height: 280px!important;">
            <img src="${cctv.image}"
                 class="w-100 h-100"
                 style="object-fit: contain;  contain; transform: scale(0.65);"
                 alt="${cctv.name}">

            <!-- Label Offline -->
            <div class="position-absolute top-50 start-50 translate-middle text-center">
              <p class="text-white-50 mb-0 small">CCTV Belum Tersedia</p>
            </div>
          </div>

          <!-- Footer -->
          <div class="card-footer bg-dark text-white py-1 px-2">
            <div class="d-flex justify-content-between align-items-center">
              <div>

                <span class="fw-bold" style="font-size: 0.8rem;">${cctv.name}</span>
              </div>
              <a href="${cctv.image}" class="cctv-popup text-white" title="${cctv.name}">
                <i class="mdi mdi-magnify"></i>
              </a>
            </div>
          </div>

        </div>
      </div>
    `;
  });

  carouselHtml += "</div>";

  $("#section-cctv").empty();
  $("#section-cctv").append(carouselHtml);

  // Owl Carousel
  $("#carousel-cctv").owlCarousel({
    loop: false,
    margin: 10,
    nav: true,
    dots: true,
    navText: [
      '<i class="mdi mdi-chevron-left"></i>',
      '<i class="mdi mdi-chevron-right"></i>',
    ],
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 },
    },
  });

  // Magnific Popup
  $(".cctv-popup").magnificPopup({
    type: "image",
    closeOnContentClick: true,
    zoom: { enabled: true, duration: 300 },
  });
}

// Contoh pemanggilan fungsi
loadCCTV("device-001");

// Bungkus filterPos dengan debounce (300ms delay)
const debouncedFilterPos = debounce(filterPos, 300);

function generatePopup(data) {
  switch (data.type) {
    case "AWLR":
      return contentPopupAwlr(data);
    case "ARR":
      return contentPopupArr(data);
    case "AWLR_ARR":
      return contentPopupAwlrArr(data);
    case "AWS":
      return contentPopupAws(data);
    case "VNOTCH":
      return contentPopupVNotch(data);
    default:
      return "";
  }
}

function adjustPadding() {
  const footers = document.querySelectorAll(".footer");
  const tabPanes = document.querySelectorAll(".tab-pane");

  // Ensure there are corresponding footers and tab-panes
  footers.forEach((footer, index) => {
    const tabPane = tabPanes[index];
    if (footer && tabPane) {
      const footerHeight = footer.offsetHeight;
      tabPane.style.paddingBottom = `${footerHeight}px`;
    }
  });
}

async function initMap() {
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

  map = new google.maps.Map(document.getElementById("map"), {
    center: { lat: parseFloat(mapLatitude), lng: parseFloat(mapLongitude) },
    zoom: parseInt(mapZoom),
    mapId: "4504f8b37365c3d0",
    mapTypeId: "hybrid",
    streetViewControl: false,
  });

  loadLegend(map);
  fetchMarkers();
  loadFlowMeterLeftBarContent();
}

function highlightSelected(id) {
  // hapus highlight dari semua card
  $(".card-station-flow").removeClass("active");
  // beri highlight ke yang dipilih
  $(`#card-station-flow-${id}`).addClass("active");
}

function closeMergedInfoWindows() {
  mergedInfoWindows.forEach((iw) => iw.close());
  mergedInfoWindows = [];
}

// Card gabungan: buka InfoWindow tiap device sekaligus
function openMergedInfoWindows(devices, baseData) {
  closeMergedInfoWindows();

  const baseLat = Number(baseData.latitude);
  const baseLng = Number(baseData.longitude);
  const positions = devices.map((d) => ({
    lat: Number(d.latitude ?? baseLat),
    lng: Number(d.longitude ?? baseLng),
  }));

  // kalau semua device berimpit di 1 titik, popup digeser agar keduanya terbaca
  const samePosition = positions.every(
    (p) =>
      Math.abs(p.lat - positions[0].lat) < 0.000001 &&
      Math.abs(p.lng - positions[0].lng) < 0.000001,
  );

  devices.forEach((device, index) => {
    const options = {
      maxWidth: 400,
      minWidth: 280,
      content: buildFlowPopupContent({ ...baseData, ...device }),
    };

    if (samePosition) {
      options.pixelOffset = new google.maps.Size(index === 0 ? -160 : 160, -25);
    }

    const iw = new google.maps.InfoWindow(options);
    const marker = markers.find(
      (m) =>
        m.deviceId &&
        String(m.deviceId).toUpperCase() ===
          String(device.deviceId || "").toUpperCase(),
    );

    if (marker && !samePosition) {
      iw.open({ anchor: marker, map });
    } else {
      iw.setPosition(positions[index]);
      iw.open(map);
    }

    mergedInfoWindows.push(iw);
  });
}

function buildFlowPopupContent(data) {
  const hasReading = data.readingHour != null;
  // popup card gabungan: nama tanpa kode device di dalam tanda kurung
  const popupName = data.isMerged ? displayStationName(data.name) : data.name;

  const dateOnlyLong = hasReading
    ? moment.parseZone(data.readingHour).locale("id").format("DD MMMM YYYY")
    : "";

  const dateOnlyShort = hasReading
    ? moment.parseZone(data.readingHour).locale("id").format("DD MMM YYYY")
    : "";

  const installedDate =
    data.installedDate == null
      ? "*"
      : moment.parseZone(data.installedDate).locale("id").format("DD MMM YYYY");

  const color_status =
    data.deviceStatus == "online" ? "text-success" : "text-danger";

  const readingSection = hasReading
    ? `
                <div class="d-flex justify-content-around reading-text">
                    <div class="col-6 text-center font-12 text-nowrap">
                        Volume Bulan Ini
                    </div>
                    <div class="col-6 text-center font-12 text-nowrap">
                        Totalizer
                    </div>
                </div>
                <div class="d-flex justify-content-around align-items-center reading-text">
                    <div class="col-6 text-center font-15 fw-bold text-dark">
                        ${
                          formatNumber(data.flowMonth) +
                          ` <span class="text-muted"><sup>${data.unitDisplay}</sup></span>`
                        }
                    </div>
                    <div class="col-6 text-center font-15 fw-bold text-dark">
                         ${
                           formatNumber(data.flowTotal) +
                           ` <span class="text-muted"><sup>${data.unitDisplay}</sup></span>`
                         }
                    </div>
                </div>
                <div class="d-flex justify-content-around mb-2 mt-0">
                    <div class="col-6 text-center font-12 text-nowrap">
                        <small class="text-muted" style="font-size: 10px; font-weight: 400; display: block; margin-top: 2px;">
                          1 - ${dateOnlyLong}
                        </small>
                    </div>
                    <div class="col-6 text-center font-12 text-nowrap">
                      <small class="text-muted" style="font-size: 10px; font-weight: 400; display: block; margin-top: 2px;">
                        ${installedDate} - ${dateOnlyShort}
                        </small>
                    </div>
                </div>`
    : `
                <div class="text-center mb-2 py-2">
                  <small class="m-0 d-flex align-items-center justify-content-center fw-normal" style="color: #ED8F2A;">
                    <i class="mdi mdi-alert-circle-outline font-14 me-1"></i>
                    Alat belum mengirim data
                  </small>
                </div>`;

  var contentString = `
                <div class="table-responsive">
                    <table class="table mb-2 font-12">
                        <tbody>
                            <tr>
                                <td class="px-0 py-2 pt-1 pe-3" colspan="3">
                                    <div class="d-flex align-items-start">
                                        <img class="me-2 rounded-3" src="/images/defaults/${defaultImage}" width="35" height="35" alt="${
                                          popupName
                                        }">
                                        <div class="w-100">
                                            <h5 class="mt-0 mb-1 fw-bold font-12" style="color: #2A62A6;">${
                                              popupName
                                            }</h5>
                                            <div class="d-flex align-items-center">
                                                <span style="text-transform: capitalize" ><small class="mdi mdi-circle ${color_status}"></small> ${data.deviceStatus} </span>
                                                ${(data.deviceIds &&
                                                data.deviceIds.length
                                                  ? data.deviceIds
                                                  : [data.deviceId]
                                                )
                                                  .map(
                                                    (id) =>
                                                      `<span class="badge badge-outline-secondary rounded-1 ms-1">${id}</span>`,
                                                  )
                                                  .join("")}
                                            <div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                ${readingSection}
                <a href="/Station/Detail/${
                  data.slug
                }" target="_blank" class="btn btn-sm btn-primary rounded-pill waves-effect waves-light text-white w-100 mb-1">Detail Pos</a>
                <a href="https://www.google.com/maps/dir/?api=1&destination=${
                  data.latitude
                },${data.longitude}"
                    target="_blank" type="button"
                    class="btn btn-sm btn-info rounded-pill waves-effect waves-light w-100 d-flex justify-content-between align-items-center">
                    <span class="mx-auto">Arah Lokasi</span>
                    <i class="mdi mdi-arrow-right"></i>
                </a>


                `;

  return contentString;
}

function showPopUp(data) {
  const mergedDevices =
    data.isMerged && Array.isArray(data.devices) && data.devices.length > 1
      ? data.devices
      : null;

  loadGrafikLast24Hour(data.deviceId, mergedDevices);

  if (!(data.latitude && data.longitude)) {
    window.open(
      `/Station/Detail/${data.slug}`,
      "_blank",
      "noopener,noreferrer",
    );
    return;
  }

  const targetLocation = {
    lat: Number(data.latitude),
    lng: Number(data.longitude),
  };

  if (infowindow) {
    infowindow.close();
  }
  closeMergedInfoWindows();

  map.setZoom(10); // Set zoom level
  map.panTo(targetLocation);

  if (mergedDevices && MERGE_POPUP_MODE === "two-windows") {
    // card gabungan -> tampilkan InfoWindow tiap device sekaligus
    openMergedInfoWindows(mergedDevices, data);
    return;
  }

  // Buka infowindow baru
  infowindow.setContent(buildFlowPopupContent(data));
  infowindow.setPosition(targetLocation);

  infowindow.setOptions({
    pixelOffset: new google.maps.Size(0, -25),
  });

  infowindow.open(map);
}

function formatNumber(input) {
  // Periksa apakah input adalah angka yang valid (bukan null, undefined, atau NaN)
  if (typeof input !== "number" || isNaN(input)) {
    return 0;
  }

  // Format angka menggunakan locale 'de-DE'
  return input.toLocaleString("de-DE");
}

function loadFlowMeterLeftBarContent() {
  getData(`/Home/GetFlowMeterLastReading`)
    .then((res) => {
      let result = res.data;

      if (result.code == 200) {
        // SIMPAN data mentah (per device) ke variabel global
        flowMeterData = result.response;

        // Device yang dikonfigurasi di MERGED_DEVICE_GROUPS digabung jadi 1 card
        const mergedData = mergeFlowMeterData(flowMeterData);

        // RENDER semua cards
        renderFlowMeterCards(mergedData);

        // UPDATE badge total = jumlah card (bukan jumlah device)
        $("#total-flow").text(mergedData.length);

        // TRIGGER klik otomatis untuk item pertama yang punya lat/lng
        const firstWithLatLng = mergedData.find(
          (x) => x.latitude && x.longitude,
        );
        if (firstWithLatLng) {
          setTimeout(() => {
            $(`#card-station-flow-${firstWithLatLng.id}`).trigger("click");
          }, 200);
        }
      }
    })
    .catch((err) => {
      console.log(err);
    });
}

function renderFlowMeterCards(data) {
  let contentLeftBar = "";

  console.log(data.filter((x) => x.deviceStatus == "offline"));

  data.forEach((item) => {
    //nanti dihapus kalau sudah diminta, sekarang dibuat default online
    //item.deviceStatus = 'online';

    const hasReading = item.readingHour != null;

    const dateTime = hasReading
      ? moment
          .parseZone(item.readingHour)
          .locale("id")
          .format("DD MMM YYYY HH:mm")
      : "";
    const dateOnlyLong = hasReading
      ? moment.parseZone(item.readingHour).locale("id").format("DD MMMM YYYY")
      : "";

    const dateOnlyShort = hasReading
      ? moment.parseZone(item.readingHour).locale("id").format("DD MMM YYYY")
      : "";

    const installedDate =
      item.installedDate == null
        ? "*"
        : moment
            .parseZone(item.installedDate)
            .locale("id")
            .format("DD MMM YYYY");

    const safeData = encodeURIComponent(JSON.stringify(item));
    const statusDevice =
      item.deviceStatus == "online" ? "text-success" : "text-danger";
    // card gabungan punya beberapa deviceId
    const deviceIds =
      item.deviceIds && item.deviceIds.length
        ? item.deviceIds
        : [item.deviceId];
    // card gabungan: nama tanpa kode device di dalam tanda kurung
    const cardName = item.isMerged ? displayStationName(item.name) : item.name;

    const cardBodyContent = hasReading
      ? `
            <div class="reading-device d-flex align-items-center justify-content-between mb-3">
              <div>

              </div>
              <span><i class="mdi mdi-battery-charging ms-1" style="color: #F69696;"></i>
                ${item.batteryVoltage == null ? "-" : item.batteryVoltage} Volt  ${item.batteryVoltage == null ? "" : `(${item.batteryCapacity}%)`}
              </span>
            </div>

            <div class="d-flex justify-content-around reading-text mb-0">
              <div class="col-6 text-center text-muted toltip-debit-bulanan" style="font-size: 12px;">Volume Bulan Ini</div>
              <div class="col-6 text-center text-muted toltip-debit-total" style="font-size: 12px;">Totalizer</div>
            </div>

            <div class="d-flex justify-content-around align-items-center reading-text mt-n1">
              <div class="col-6 text-center">
                <h4 id="flow-month" class="text-dark mb-0" style="line-height: 1;">
                  ${item.flowMonth == null ? "-" : formatNumber(item.flowMonth)}
                  <span class="text-muted" style="font-size: 1em;"><sup>${item.unitDisplay ?? ""}</sup></span>
                </h4>
              </div>
              <div class="col-6 text-center">
                <h4 id="flow-total" class="text-dark mb-0" style="line-height: 1;">
                  ${item.flowTotal == null ? "-" : formatNumber(item.flowTotal)}
                  <span class="text-muted" style="font-size: 1em;"><sup>${item.unitDisplay ?? ""}</sup></span>
                </h4>
              </div>
            </div>

            <div class="d-flex justify-content-around">
              <div class="col-6 text-center toltip-debit-bulanan">
                <small class="text-muted" style="font-size: 10px; font-weight: 400; display: block; margin-top: 2px;">
                  1 - ${dateOnlyLong}
                </small>
              </div>
              <div class="col-6 text-center toltip-debit-total">
                <small class="text-muted" style="font-size: 10px; font-weight: 400; display: block; margin-top: 2px;">
                  ${installedDate} - ${dateOnlyShort}
                </small>
              </div>
            </div>`
      : `
            <div class="text-center py-2">
              <small class="m-0 d-flex align-items-center justify-content-center fw-normal" style="color: #ED8F2A;">
                <i class="mdi mdi-alert-circle-outline font-14 me-1"></i>
                Alat belum mengirim data
              </small>
            </div>`;

    contentLeftBar += `
      <div class="card-station-flow"
          data-ts-id="${item.id}"
          data-item='${safeData}'
          data-status='${item.deviceStatus}'
          data-jenis-usaha='${item.jenisUssaha}'
          data-name="${cardName.toLowerCase()}"
          data-device-id="${deviceIds
            .map((id) => String(id).toLowerCase())
            .join(" ")}"
          data-merged="${item.isMerged ? "true" : "false"}"
          id="card-station-flow-${item.id}">
        <div class="card card-station animate__animated animate__fadeInLeft">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <h4 class="card-title text-uppercase text-station-name m-0 text-truncate" style="cursor-help; color: #2A62A6;" data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="${cardName}">
                ${cardName}
              </h4>
              <span class="reading-at ms-auto fw-semibold" id="last-reading">${dateTime}</span>
              ${item.isMerged ? `<i class="mdi mdi-chevron-down device-breakdown-toggle text-muted ms-1" style="font-size: 14px;"></i>` : ""}
            </div>
            <div class="d-flex align-items-center " style="margin-top:2px;">
              <h4 class="card-title text-uppercase text-station-name m-0">
                <small class="mdi mdi-circle ${statusDevice} me-1"></small>
                <span class="text-muted" style="text-transform: capitalize;">${item.deviceStatus}</span>
                ${deviceIds
                  .map(
                    (
                      id,
                    ) => `<span class="badge badge-outline-secondary rounded-1 ms-1"
                      style="color: #A9ABB8;border-color: #A9ABB8;">
                  ${id}
                </span>`,
                  )
                  .join("")}
                <span class="badge badge-outline-secondary rounded-1 ms-1"
                      style="color: #A9ABB8;border-color: #A9ABB8;">
                  Pertanian
                </span>
              </h4>
              <span class="reading-at ms-auto fw-semibold"></span>
            </div>
          </div>
          <div class="card-body">
            ${cardBodyContent}
          </div>
        </div>
        ${
          item.isMerged
            ? `<div class="device-breakdown" style="display: none;">
            ${buildDeviceBreakdownContent(item.devices, item.unitDisplay)}
          </div>`
            : ""
        }
      </div>`;
  });

  $("#tab-flow").html(contentLeftBar);
  setTimeout(adjustPadding, 100);
}

// Handler klik pakai jQuery (delegated)
$(document).on("click", ".card-station-flow", function (e) {
  // Baris rincian device bisa diklik sendiri -> popup & grafik device itu saja
  const $breakdownItem = $(e.target).closest(".device-breakdown-item");
  if ($breakdownItem.length) {
    $(".card-station-flow").removeClass("active");
    $(this).addClass("active");
    $(".device-breakdown-item").removeClass("active");
    $breakdownItem.addClass("active");

    const rawDevice = $breakdownItem.attr("data-device-item");
    if (rawDevice) {
      const deviceData = JSON.parse(decodeURIComponent(rawDevice));
      console.log(deviceData);
      // deviceData tidak punya isMerged -> 1 popup marker + 1 series grafik
      showPopUp(deviceData);
    }
    return;
  }

  // Hilangkan highlight semua
  $(".card-station-flow").removeClass("active");
  $(".device-breakdown-item").removeClass("active");
  // Tambahkan highlight ke yang diklik
  $(this).addClass("active");

  // Ambil data JSON
  const raw = $(this).attr("data-item");
  const data = JSON.parse(decodeURIComponent(raw));

  console.log(data);

  // Klik di dalam panel rincian (bukan baris device) tidak men-toggle
  if (!$(e.target).closest(".device-breakdown").length) {
    // Card apa pun yang diklik -> tutup panel rincian card lain
    $(".card-station-flow")
      .not(this)
      .each(function () {
        const $other = $(this).children(".device-breakdown");
        if ($other.length && $other.is(":visible")) {
          $other.stop(true, true).slideUp(200);
          $(this)
            .find(".device-breakdown-toggle")
            .removeClass("mdi-chevron-up")
            .addClass("mdi-chevron-down");
        }
      });

    // Card gabungan (2 device) -> buka/tutup rincian tiap device
    if (data.isMerged) {
      const $breakdown = $(this).children(".device-breakdown");
      if ($breakdown.length) {
        $breakdown.stop(true, true).slideToggle(200);
        $(this)
          .find(".device-breakdown-toggle")
          .toggleClass("mdi-chevron-down mdi-chevron-up");
      }
    }
  }

  //loadCCTV(data.deviceId);

  // Jalankan popup
  showPopUp(data);
});

function loadLegend(map) {
  $.ajax({
    url: "/station/type/total", // URL API
    method: "GET", // HTTP Method
    success: function (response) {
      const stationConfig = {
        flow: { name: "Pos Duga Air", classMarker: "flow-marker me-1" },
        ARR: { name: "Pos Curah Hujan", classMarker: "arr-marker me-1" },
        VNOTCH: { name: "Pos V-Notch", classMarker: "vnotch-marker me-1" },
        AWS: { name: "Pos Klimatologi", classMarker: "aws-markers me-1" },
        WQ: { name: "Pos Kualitas Air", classMarker: "wq-marker me-1" },
        FM: { name: "Pos Flow Meter", classMarker: "fm-marker me-1" },
        flow_ARR: { name: "PDA & PCH", classMarker: "flow-arr-marker me-1" },
        OSP: { name: "Pos OSP", classMarker: "osp-marker me-1" },
        AVWR: { name: "Pos Vibrating Wire", classMarker: "osp-marker me-1" },
      };

      var legendDiv = document.createElement("div");
      let parentDiv = ` <div>`;
      parentDiv += ` <div class="p-2 mb-1" style="background-color: white;box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);border-radius: 6px;">`;

      parentDiv += ` <h6 class="fw-bold m-0 mb-1">Tipe Pos</h6>`;

      response.forEach((lgn) => {
        if (stationConfig[lgn.type] != undefined) {
          parentDiv += `<div class="d-flex align-items-center justify-content-between">
                      <div class="${
                        stationConfig[lgn.type].classMarker
                      }" style="width: 18px;height: 18px;box-shadow:none;"></div>
                      <div class="me-1" style="font-weight: bold;">${
                        stationConfig[lgn.type].name
                      }</div>
                      <input  name="tipe-sensor" value="${
                        lgn.type
                      }" type="checkbox" checked onchange="changeMarker(this)" />
                  </div>`;
        }
      });

      parentDiv += `<p class="mb-0 mt-2 text-muted small fw-semibold">T = Telemetri</p>`;
      parentDiv += `</div>`;

      legendDiv.innerHTML = parentDiv;
      legendDiv.style.marginLeft = "10px";
      map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legendDiv);
    },
    error: function (xhr, status, error) {
      console.info(error);
    },
  });
}
// Fungsi untuk mengambil data dari API
async function fetchMarkers() {
  try {
    const response = await fetch("/Home/Markers");
    const data = await response.json();
    markerData = data;
    addMarkers(markerData);
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}
// Fungsi untuk menambahkan marker ke peta
async function addMarkers(data) {
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
  data.forEach((el) => {
    if (String(el.type || "").toUpperCase() === "EWS") return;

    // Create marker
    const lastData = el.lastData.split("|");
    const flowMonth = lastData[1] || 0;
    const flowTotal = lastData[2] || 0;
    const modelData = {
      brandName: el.brandName,
      deviceId: el.deviceId,
      deviceStatus: el.deviceStatus,
      //deviceStatus: "online", // kembalikan seperti di atas, jika sudah diminta
      readingHour: el.lastReading,
      flowMonth: parseFloat(flowMonth),
      flowTotal: parseFloat(flowTotal),
      slug: el.slug,
      name: el.name,
      latitude: parseFloat(el.latitude),
      longitude: parseFloat(el.longitude),
      unitDisplay: el.unit || "m3",
    };
    const customMarker = document.createElement("div");
    switch (el.type) {
      case "flow":
        switch (parseInt(el.status)) {
          case 0:
            customMarker.className = `flow-marker`;
            break;
          case 3:
            customMarker.className = `flow-marker alert-siaga3`;
            break;
          case 2:
            customMarker.className = `flow-marker alert-siaga2`;
            break;
          case 1:
            customMarker.className = `flow-marker alert-siaga1`;
            break;
          default:
            customMarker.className = `flow-marker`;
            break;
        }
        break;
      case "ARR":
        customMarker.className = `arr-marker`;
        break;
      case "AWS":
        customMarker.className = `aws-marker`;
        break;
      case "FM":
        customMarker.className = `fm-marker`;
        break;
      case "VNOTCH":
        customMarker.className = `vnotch-marker`;
        break;
      default:
        break;
    }

    if (el.latitude != null && el.longitude != null) {
      const marker = new AdvancedMarkerElement({
        map,
        position: {
          lat: parseFloat(el.latitude),
          lng: parseFloat(el.longitude),
        },
        content: customMarker,
      });

      markers.push(marker);
      // dipakai untuk meng-anchor InfoWindow card gabungan ke marker device-nya
      marker.deviceId = el.deviceId;

      // Menambahkan event listener untuk marker
      google.maps.event.addListener(marker, "click", function () {
        // showInfoWindow(el, marker);
        showPopUp(modelData);
      });
    }
  });
}

function getCheckedSensors() {
  // Ambil semua elemen checkbox dengan name="tipe-sensor"
  const checkboxes = document.querySelectorAll(
    'input[name="tipe-sensor"]:checked',
  );
  // Map hasilnya menjadi array yang berisi nilai 'value' dari checkbox yang tercentang
  const checkedValues = Array.from(checkboxes).map(
    (checkbox) => checkbox.value,
  );
  // Kembalikan array nilai yang tercentang
  return checkedValues;
}

function changeMarker(input) {
  const value = $(input).val();
  let checked = true;
  if (input.checked) {
    checked = true;
  } else {
    checked = false;
  }
  filterMarkers(value, checked);
}

// Fungsi untuk memfilter marker berdasarkan kategori
function filterMarkers(category, status) {
  // Hapus semua marker dari peta
  clearMarkers();
  let filterData = markerData;

  const sensors = getCheckedSensors();
  filterData = filterData.filter((dt) => sensors.includes(dt.type));

  // Tambahkan marker yang terfilter ke peta
  addMarkers(filterData);
}

// Fungsi untuk menghapus marker dari peta
function clearMarkers() {
  for (let i = 0; i < markers.length; i++) {
    markers[i].setMap(null);
  }
  markers = []; // Reset array marker
}

// Fungsi untuk menampilkan InfoWindow saat marker diklik
function showInfoWindow(data, marker) {
  if (infowindow) {
    infowindow.close();
  }
  let contentPopup = generatePopup(data);
  // Buka infowindow baru
  infowindow = new google.maps.InfoWindow({
    content: contentPopup,
    disableAutoPan: true,
  });
  infowindow.open({
    anchor: marker,
    map,
  });
}

// Card gabungan memakai devices[] -> tiap device di-request dan digambar
// sebagai series sendiri (2 garis), bukan dijumlahkan
function loadGrafikLast24Hour(device, devices) {
  const deviceIds =
    Array.isArray(devices) && devices.length > 1
      ? devices.map((d) => d.deviceId)
      : [device];

  Promise.all(
    deviceIds.map((id) =>
      $.ajax({
        url: "/Home/GetFlowLast24Hour",
        type: "GET",
        data: { deviceId: id },
        dataType: "json",
      }),
    ),
  )
    .then((results) => loadHighchart(buildFlowSeries(deviceIds, results)))
    .catch((error) => console.error("Terjadi kesalahan:", error));
}

// Satu series per device supaya 2 device tampil sebagai 2 garis
function buildFlowSeries(deviceIds, seriesList) {
  return (seriesList || []).map((list, index) => ({
    name: String(deviceIds[index] || `Device ${index + 1}`).toUpperCase(),
    data: (Array.isArray(list) ? list : [])
      .filter((point) => point != null && point.millis != null)
      .map((point) => [point.millis, Number(point.value) || 0])
      .sort((a, b) => a[0] - b[0]),
  }));
}

async function lastReading(device) {
  $.ajax({
    url: "/Home/GetFlowLastReading",
    type: "GET",
    data: { deviceId: device },
    dataType: "json",
    success: async function (response) {
      console.log("Data berhasil diambil:", response);
      const cost = formatRupiah(response);
      const lastReading = moment
        .parseZone(moment(response.readingAtUtc).format("D MMMM YYYY HH:mm"))
        .locale("id")
        .format("D MMMM YYYY HH:mm");
      $("#flow-month").html(
        `${
          response.flowMonth
        } <small class="text-muted">m<sup>3</sup></small><span class="mx-1">/</span>${
          response.flowMonth * 1000
        } <small class="text-muted">lt</small>`,
      );
      $("#cost-month").html(`${cost}`);
      $("#flow-total").html(
        `${
          response.flowTotal
        } <small class="text-muted">m<sup>3</sup></small><span class="mx-1">/</span>${
          response.flowMonth * 1000
        } <small class="text-muted">lt</small>`,
      );
      $("#battery").html(
        `<i class="mdi mdi-battery-charging-high ms-1" style="color: #F69696;"></i> ${
          response.battery
        } <small>volt</small> (${getBatteryCapacity12V(response.battery)}%)`,
      );
      $("#last-reading").html(`${lastReading}`);

      const { AdvancedMarkerElement } =
        await google.maps.importLibrary("marker");
      const customMarker = document.createElement("div");
      customMarker.className = `fm-marker`;

      const marker = new AdvancedMarkerElement({
        map,
        position: { lat: -2.2524838890950383, lng: 113.92042208465449 },
        content: customMarker,
      });

      var contentString = `
                <div class="table-responsive">
                    <table class="table mb-2 font-12">
                        <tbody>
                            <tr>
                                <td class="px-0 py-2 pt-1 pe-3" colspan="3">
                                    <div class="d-flex align-items-start">
                                        <img class="me-2 rounded-3" src="/images/defaults/${defaultImage}" width="35" height="35" alt="POS FLOW METER 1">
                                        <div class="w-100">
                                            <h5 class="mt-0 mb-1 fw-bold font-12" style="color: #2A62A6;">POS FLOW METER 1</h5>
                                            <div class="d-flex align-items-center">
                                                <span><small class="mdi mdi-circle text-success"></small> Online</span>
                                                <span class="badge badge-outline-secondary rounded-1 ms-1">HGT821</span>
                                            <div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="d-flex justify-content-around align-items-center mb-1 reading-text">
                    <div class="col-6 text-center font-15 fw-bold text-dark">
                        ${
                          response.flowMonth
                        } <small class="text-muted">m<sup>3</sup></small><span class="mx-1">/</span>${
                          response.flowMonth * 1000
                        } <small class="text-muted">lt</small>
                    </div>
                    <div class="col-6 text-center font-15 fw-bold text-dark">
                        ${
                          response.flowTotal
                        } <small class="text-muted">m<sup>3</sup></small><span class="mx-1">/</span>${
                          response.flowMonth * 1000
                        } <small class="text-muted">lt</small>
                    </div>
                </div>
                <div class="d-flex justify-content-around reading-text mb-2">
                    <div class="col-6 text-center font-12 text-nowrap">
                        Volume Bulan Ini
                    </div>
                    <div class="col-6 text-center font-12 text-nowrap">
                        Totalizer
                    </div>
                </div>
                <a href="/Station/Detail/flowmeter-1" target="_blank" class="btn btn-sm btn-primary rounded-pill waves-effect waves-light text-white w-100 mb-1">Detail Pos</a>
                <a href="https://www.google.com/maps/dir/?api=1&destination=-2.2524517274565783,113.9205079153455"
                    target="_blank" type="button"
                    class="btn btn-sm btn-info rounded-pill waves-effect waves-light w-100 d-flex justify-content-between align-items-center">
                    <span class="mx-auto">Arah Lokasi</span>
                    <i class="mdi mdi-directions"></i>
                </a>


                `;

      let infowindow = new google.maps.InfoWindow({
        maxWidth: 400,
        minWidth: 280,
      });

      marker.addListener("click", () => {
        if (infowindow) {
          infowindow.close();
        }

        // Buka infowindow baru
        infowindow.setContent(contentString);
        infowindow.open({
          anchor: marker,
          map,
        });
      });

      markers.push(marker);
    },
    error: function (xhr, status, error) {
      console.error("Terjadi kesalahan:", error);
    },
  });
}

// series: [{ name, data: [[millis, value], ...] }, ...]
function loadHighchart(series) {
  // Hapus spinner dan ubah class agar grafik memenuhi div
  let chartContainer = document.getElementById("section-garfik");
  chartContainer.innerHTML = ""; // Kosongkan kontainer
  chartContainer.classList.remove(
    "d-flex",
    "justify-content-center",
    "align-items-center",
  );

  // Buat elemen div baru untuk chart
  let chartDiv = document.createElement("div");
  chartDiv.style.width = "100%";
  chartDiv.style.height = "100%";
  chartContainer.appendChild(chartDiv);
  // Render Highcharts
  Highcharts.chart(chartDiv, {
    chart: {
      type: "line",
      zoomType: "x",
    },
    title: {
      text: "",
    },
    subtitle: {
      text: "Data 24 Jam Terakhir",
    },
    xAxis: {
      type: "datetime",
      title: { text: "Waktu" },
      labels: {
        format: "{value:%H:%M}", // Format waktu 24 jam tanpa AM/PM
      },
    },
    yAxis: {
      title: { text: "Debit (m³/jam)" },
    },
    tooltip: {
      shared: true,
    },
    legend: {
      enabled: true,
      align: "center",
      verticalAlign: "bottom",
    },
    series: (series || []).map((item) => ({
      name: item.name,
      data: item.data,
      marker: {
        enabled: true, // Aktifkan marker
        radius: 2.5, // Ukuran marker (default 4, ubah ke 6)
        symbol: "circle", // Bentuk marker
      },
    })),
  });
}

function formatRupiah(amount) {
  if (isNaN(amount)) return "Rp 0";
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
  }).format(amount);
}

function loadSummaryStation() {
  $.ajax({
    url: `/Home/GetSumarryPos`,
    type: "GET",
    beforeSend: function () {
      console.log("loading data summary");
    },
    success: function (response) {
      $("#total-station").empty();
      $("#total-online").empty();
      $("#total-offline").empty();

      // badge tab flow meter dipegang loadFlowMeterLeftBarContent (jumlah card)
      $("#total-station").html(response.total);
      $("#total-online").html(response.online);
      $("#total-offline").html(response.offline);
      //$('#total-offline').html('0');
    },
    error: function (xhr, status, error) {
      // Respons jika request gagal
      console.log(`Error in function getTotalSTationType(). Message: ${error}`);
    },
  });
}

function loadShimmerLastReading() {
  var totalShimmer = 5;
  var contentShimmer = ``;

  for (let i = 1; i <= totalShimmer; i++) {
    contentShimmer += `<div class="card card-station mb-2">
                            <div class="card-body">
                                <div class="d-flex justify-content-start mb-2">
                                    <box class="shine me-2" style="width: 3rem;height: 3rem;"></box>
                                    <div class="col-md-8">
                                        <div class="box-shine-3 shine m-0"></div>
                                        <div class="box-shine-1 shine m-0"></div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-around reading-text mb-2">
                                    <div class="text-center">
                                        <div class="box-shine-1 shine" style="width: 3rem;"></div>
                                        <br>
                                        <div class="box-shine-2 shine" style="width: 5rem;"></div>
                                    </div>
                                    <div class="text-center">
                                        <div class="box-shine-1 shine" style="width: 3rem;"></div>
                                        <br>
                                        <div class="box-shine-2 shine" style="width: 5rem;"></div>
                                    </div>
                                    <div class="text-center">
                                        <div class="box-shine-1 shine" style="width: 3rem;"></div>
                                        <br>
                                        <div class="box-shine-2 shine" style="width: 5rem;"></div>
                                    </div>
                                </div>
                                <div class="box-shine-3 shine"></div>
                            </div>
                        </div>`;
  }

  return `
                        <div class="row">
                            <div class="col-12">
                                ${contentShimmer}
                            </div>
                        </div>
                    `;
}

$(document).ready(function () {
  // Inisialisasi semua tooltip di halaman

  $("#tab-flow").html(loadShimmerLastReading());
  initMap();
  loadSummaryStation();
});

function getBatteryCapacity12V(voltage) {
  // Define the voltage-to-capacity mapping as an array of objects
  const voltageCapacityMap = [
    { voltage: 13.0, capacity: 100 },
    { voltage: 12.8, capacity: 99 },
    { voltage: 12.75, capacity: 90 },
    { voltage: 12.5, capacity: 80 },
    { voltage: 12.3, capacity: 70 },
    { voltage: 12.15, capacity: 60 },
    { voltage: 12.05, capacity: 50 },
    { voltage: 11.95, capacity: 40 },
    { voltage: 11.81, capacity: 30 },
    { voltage: 11.66, capacity: 20 },
    { voltage: 11.51, capacity: 10 },
    { voltage: 10.5, capacity: 0 },
  ];

  // Iterate through the mapping to find the closest range
  for (let i = 0; i < voltageCapacityMap.length - 1; i++) {
    const { voltage: v1, capacity: c1 } = voltageCapacityMap[i];
    const { voltage: v2, capacity: c2 } = voltageCapacityMap[i + 1];

    if (voltage >= v2 && voltage <= v1) {
      // Linear interpolation between two points
      const fraction = (voltage - v2) / (v1 - v2);
      return Math.round(c2 + fraction * (c1 - c2));
    }
  }

  // If voltage is outside the range, return 0 or 100
  return voltage > 26.0 ? 100 : null;
}
